import { IonBackButton, IonButtons, IonContent, IonHeader, IonPage, IonSpinner, IonToolbar } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router";
import { useRecoilState } from "recoil";
import { IUser } from "@interfaces/Interfaces";
import { userAtom } from "@state/State";
import validator from "validator";
import "./EditRole.css";
import * as DatabaseService from "@controllers/DatabaseService";
import * as FirebaseService from "@controllers/FirebaseService";
import DataController from "@controllers/DataController";
import HeaderTitle from "@components/common/HeaderTitle";
import { Capacitor } from "@capacitor/core";
import ContentContainer from "@components/common/ContentContainer";
import { useHidingTabBar } from "@hooks/tabs/useHidingTabBar";

const EditRole: React.FC = () => {
  const HCPCInputRef = useRef<HTMLInputElement>(null);

  useHidingTabBar();
  const [user, setUser] = useRecoilState<IUser | null>(userAtom);

  const [HCPCNumber, setHCPCNumber] = useState<string>(user?.HCPCNumber || "");
  const [savingHCPCNumber, setSavingHCPCNumber] = useState<boolean>(false);

  useEffect(() => {
    const setPageName = async (): Promise<void> => {
      await FirebaseService.setScreenName("edit");
    };

    setPageName();
  }, []);

  const validateHCPCNumber = (number: string): boolean => {
    return validator.matches(number, /^[a-zA-Z0-9]{0,20}$/gim);
  };

  const HCPCKeyPressed = (event: React.KeyboardEvent): void => {
    if (event.key === "Enter") {
      if (!savingHCPCNumber && HCPCNumber !== user?.HCPCNumber && HCPCNumber !== "") {
        event.preventDefault();

        saveHCPCNumber();
      }
    }
  };

  const HCPCNumberChanged = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (validateHCPCNumber(event.target.value)) {
      setHCPCNumber(event.target.value.toUpperCase());
    } else {
      setHCPCNumber(
        event.target.value
          .toUpperCase()
          .replace(/[^a-zA-Z0-9]/gim, "")
          .substring(0, 20)
      );
    }
  };

  const saveHCPCNumber = async (): Promise<void> => {
    try {
      setSavingHCPCNumber(true);

      const userToSave: IUser = { ...user };

      if (userToSave) {
        userToSave.HCPCNumber = HCPCNumber;

        await DatabaseService.updateUserDetails(userToSave, {
          HCPCNumber,
        });

        setUser(userToSave);

        setTimeout(() => {
          setSavingHCPCNumber(false);
        }, 1000);
      }
    } catch (error) {
      console.log(error);
      setSavingHCPCNumber(false);
      window.alert("Failed to update registration number. Please try again");
    }
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          mode="ios"
          className="navBar"
          style={{
            maxWidth: DataController.isWeb() ? 980 : undefined,
            height: Capacitor.getPlatform() === "android" ? "54px" : "unset",
          }}
        >
          <IonButtons slot="start">
            <IonBackButton
              className="header-back-buttons"
              defaultHref="/profile"
              text={DataController.getBackIconText()}
              icon={DataController.getBackIconType()}
              style={{
                marginLeft: Capacitor.getPlatform() === "android" ? 8 : 0,
                "--icon-font-size": Capacitor.getPlatform() === "android" ? "24px" : "30px",
              }}
            />
          </IonButtons>
          <HeaderTitle>{"Edit Profile"}</HeaderTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="page-background whiteBackground">
        <ContentContainer
          className="!pt-0 pb-4"
          style={{ paddingTop: 0, alignSelf: "center" }}
        >
          <div className="mx-auto max-w-app-column pt-4">
            <div className="onboardingDateHeader">{"Registration number"}</div>
            <div style={{ position: "relative" }}>
              <input
                ref={HCPCInputRef}
                className="hcpcInputContainer"
                placeholder="Add your registration number..."
                autoComplete="off"
                autoCapitalize="characters"
                id="HCPCNumberInput"
                value={HCPCNumber}
                pattern="[a-zA-Z0-9]+"
                onChange={HCPCNumberChanged}
                onKeyUp={HCPCKeyPressed}
              />
              {savingHCPCNumber ? (
                <div className="saveHCPCButtonSpinnerContainer">
                  <IonSpinner className="saveHCPCButtonSpinner" />
                </div>
              ) : (
                <button
                  className="saveHCPCButton"
                  disabled={HCPCNumber === user?.HCPCNumber || HCPCNumber === ""}
                  onClick={() => saveHCPCNumber()}
                >
                  {"Save"}
                </button>
              )}
            </div>
          </div>
        </ContentContainer>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(EditRole);
